import OrderLineButtons from '@/atoms/order-line-buttons';
import OrderLineItem from '@/molecules/order-line-item';

import { OrderLine } from './OrderLine';

export type TypeOrderLine = typeof OrderLine & {
  Item: typeof OrderLineItem;
  Buttons: typeof OrderLineButtons;
};

(OrderLine as TypeOrderLine).Item = OrderLineItem;
(OrderLine as TypeOrderLine).Buttons = OrderLineButtons;

OrderLineItem.displayName = 'OrderLine.Item';
OrderLineButtons.displayName = 'OrderLine.Buttons';

export type { TypeOrderLineProps } from './types';
export type { TypeOrderLineButtonsProps } from '@/atoms/order-line-buttons';
export type { TypeOrderLineItemProps } from '@/molecules/order-line-item';
export default OrderLine as TypeOrderLine;
